import type { ComponentPropsWithRef } from "react";
import { forwardRef, memo } from "react";
import classNames from "classnames";
import deepEqual from "fast-deep-equal";
import { DirectHTMLRenderer } from "./DirectHTMLRenderer";

export interface CustomHTMLProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: {
    head: string;
    body: string;
  };
  "data-preview-mode"?: boolean;
  id: string;
}

const CustomHTMLComponent = forwardRef<HTMLDivElement, CustomHTMLProps>(
  (
    {
      content,
      className,
      id,
      "data-preview-mode": isPreviewMode = false,
      ...rest
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={classNames("wb-w-full wb-min-h-4", className)}
      id={id}
      data-testid="custom-html-renderer-parent"
      {...rest}
    >
      <DirectHTMLRenderer
        head={content.head}
        body={content.body}
        isPreviewMode={isPreviewMode}
      />
    </div>
  ),
);

CustomHTMLComponent.displayName = "CustomHTML";

export const CustomHTML = memo(CustomHTMLComponent, deepEqual);
